import { Panel } from "components/Panel/Panel";
import { ReactNode } from "react";
import { CenterFlexDiv, MaxWidth } from "styles/layout";
import { EmptyGrowPanelText } from "styles/text";
import { PageContent, GrowColumn, ColumnContainer } from "./styles";

interface Props {
  children: ReactNode;
}

export const SingleColumnPage = ({ children }: Props) => {
  return (
    <PageContent>
      <MaxWidth>
        <ColumnContainer>
          <GrowColumn>{children}</GrowColumn>
        </ColumnContainer>
      </MaxWidth>
    </PageContent>
  );
};

export const MultiColumnPage = ({ children }: Props) => {
  return (
    <PageContent>
      <MaxWidth>
        <ColumnContainer>{children}</ColumnContainer>
      </MaxWidth>
    </PageContent>
  );
};

export const CenterPage = ({ children }: Props) => {
  return (
    <CenterFlexDiv>
      <PageContent>{children}</PageContent>
    </CenterFlexDiv>
  );
};

interface ErrorProps {
  message: string;
}

export const ErrorMessagePage = ({ message }: ErrorProps) => {
  return (
    <PageContent>
      <MaxWidth>
        <ColumnContainer>
          <GrowColumn>
            <Panel>
              <EmptyGrowPanelText>{message}</EmptyGrowPanelText>
            </Panel>
          </GrowColumn>
        </ColumnContainer>
      </MaxWidth>
    </PageContent>
  );
};
